import * as React from 'react';
import { SVGProps } from 'react';

const IconDataNullSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.703 4.445A1 1 0 0 1 5.535 4h12.93a1 1 0 0 1 .832.445l3.535 5.303a1 1 0 0 1 .168.555V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-8.697a1 1 0 0 1 .168-.555l3.535-5.303ZM6 6h12l2.5 4H18a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H3.5L6 6Z"
    />
  </svg>
);
export default IconDataNullSizeM;
